import React from "react";
import {CircularProgress} from "@mui/material";

const Loading = () => {
    return (
        <div style={{
            display: 'flex',
            height: '85vh',
            width: '100%',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <div style={{width: 'fit-content'}}>
                <CircularProgress size={64}/>
            </div>
        </div>
    );
};

export default Loading;